import PropTypes from 'prop-types';

import Badge from 'components/field/Badge';
import Image from 'components/global/Image';
import Radio from 'components/global/Radio';
import Typography from 'components/global/Typography';

import * as S from '../OnlineStores/OnlineStores.styled';

const ConnectionWayCard = ({ connectionWay, isSelected, onSelect }) => (
	<S.ConnectionWaysCard className={isSelected ? 'selected' : ''} onClick={() => onSelect(connectionWay)}>
		<S.ConnectionWaysCardContent>
			<Image url={connectionWay.icon} height="59px" alt={connectionWay.integrationName} width="unset" />
			<S.ConnectionWaysTextContainer>
				<S.ConnectionWaysCardTitle>
					<Typography variant="p2" fontWeight="500">
						{connectionWay.integrationName}
					</Typography>
					{connectionWay.badge && <Badge variant="pill" color="teel" text={connectionWay.badge} />}
				</S.ConnectionWaysCardTitle>
				<Typography variant="p3" noWrap>
					{connectionWay.description}
				</Typography>
			</S.ConnectionWaysTextContainer>
		</S.ConnectionWaysCardContent>
		<Radio readOnly checked={isSelected} />
	</S.ConnectionWaysCard>
);

ConnectionWayCard.propTypes = {
	connectionWay: PropTypes.object.isRequired,
	isSelected: PropTypes.bool.isRequired,
	onSelect: PropTypes.func.isRequired
};

export default ConnectionWayCard;
